import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { AVAILABLE_LANGUAGES } from '../../config/languages';

import Link from '../helpers/Link';

const HeaderLanguage = ({
    openPage, language, page, subpage, closeMenu
}) => {
    if (AVAILABLE_LANGUAGES.length <= 1) {
        return null;
    }

    return (
        <ul className="header-language">
            {
                AVAILABLE_LANGUAGES.map((lang) => (
                    <li className={ cx({ active: (lang === language) }) } key={ lang } id={ lang }>
                        <Link
                          openPage={ openPage }
                          language={ lang }
                          page={ page }
                          subpage={ subpage }
                          callback={ closeMenu }
                          scroll={ false }
                          className="link"
                        >
                            { lang.toUpperCase() }
                        </Link>
                    </li>
                ))
            }
        </ul>
    );
};

HeaderLanguage.defaultProps = {
    subpage: null
};

HeaderLanguage.propTypes = {
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    closeMenu: PropTypes.func.isRequired
};

export default HeaderLanguage;



// WEBPACK FOOTER //
// ./src/components/header/HeaderLanguage.jsx